import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((cfg) => {
    const t = localStorage.getItem("fz_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

export default api;

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Une erreur est survenue";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" · ");
    return String(d);
}
